import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED} from '../../../../share/util/api/polling';

/**
 * 終了処理メソッド
 */
export async function standbyApi(self) {
  try {
    self.isLoading = true;
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'standby'
      },
      // エラー発生のコールバック
      (errorType) => { errorType; self.showError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      (result) => { self.validateErrorResult(result); },
    );
    if (response) {
      // セッション遷移の状態を更新 取得できない場合はtrueをセットしてexit APIを呼び出す
      self.isSession = response.data?.user_data?.is_session ?? true;
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          await self.executeProcess(response.data.user_data.is_send_iot);
          break;
        default:
          await self.showError();
          break;
      }
    }
  }
  finally {
    self.isLoading = false;
  }
}